import {Action, ActionReducerMap} from '@ngrx/store';

import * as actionsUi from './veranstaltungen.actions.ui';
import {
    AKTUELLES_DOKUMENT_AENDERN,
    AktuellesDokumentAendernAction,
    AUFGABE_SETZEN,
    AufgabeSetzenAction,
    DOKUMENT_BEARBEITEN_BERECHTIGUNGEN_SELECTED_SETZEN,
    DOKUMENT_ID_SETZEN,
    DOKUMENT_LESE_BERECHTIGUNGEN_SELECTED_SETZEN,
    DOKUMENT_SELECTED_SETZEN,
    DOKUMENT_UPLOAD_SETZEN,
    DokumentBearbeitenBerechtigungenSelectedSetzenAction,
    DokumentIdSetzenAction,
    DokumentLeseBerechtigungenSelectedSetzenAction,
    DokumentSelectedSetzenAction,
    DokumentUploadSetzenAction, FUNKTIONSBEREICH_SETZEN, FunktionsbereichSetzenAction,
    NeueVeranstaltungDetailSetzenAction,
    ROLLE_SETZEN,
    RolleSetzenAction, SET_SELECTED_AUFGABEN, SetSelectedAufgabenAction,
    SETZE_PANDEMIE_LEVEL_UI,
    SETZE_VERANSTALTUNG_BEGINN,
    SETZE_VERANSTALTUNG_EINLASS,
    SETZE_VERANSTALTUNG_FELD,
    SETZE_VERANSTALTUNG_SAISON,
    SETZE_VERANSTALTUNG_STICHTAG_PANDEMIE_LEVEL,
    SETZE_VERANSTALTUNG_TITEL,
    SETZE_VERANSTALTUNG_VERANSTALTUNGSBEOBACHTER,
    SETZE_VERANSTALTUNG_VERANSTALTUNGSLEITER,
    SetzePandemieLevelUiAction,
    SetzeVeranstaltungBeginnAction,
    SetzeVeranstaltungEinlassAction,
    SetzeVeranstaltungFeldAction,
    SetzeVeranstaltungSaisonAction,
    SetzeVeranstaltungStichtagPandemieLevelAction,
    SetzeVeranstaltungTitelAction,
    SetzeVeranstaltungVeranstaltungsbeobachterAction,
    SetzeVeranstaltungVeranstaltungsleiterAction
} from './veranstaltungen.actions.ui';
import {
    GET_CHECKLISTE_ABARBEITER_ROLLEN_ADMIN,
    GET_CHECKLISTE_ABARBEITER_ROLLEN_ADMIN_ERFOLGREICH,
    GET_CHECKLISTE_ABARBEITER_ROLLEN_ADMIN_FEHLER,
    GET_CHECKLISTE_AUFGABEN_ADMIN,
    GET_CHECKLISTE_AUFGABEN_ADMIN_ERFOLGREICH,
    GET_CHECKLISTE_AUFGABEN_ADMIN_FEHLER,
    GET_CHECKLISTE_FREIGABE_ROLLEN_ADMIN,
    GET_CHECKLISTE_FREIGABE_ROLLEN_ADMIN_ERFOLGREICH,
    GET_CHECKLISTE_LESE_ROLLEN_ADMIN,
    GET_CHECKLISTE_LESE_ROLLEN_ADMIN_ERFOLGREICH,
    GET_CHECKLISTE_LESE_ROLLEN_ADMIN_FEHLER,
    GET_FUNKTIONSBEREICH_CHECKLISTEN_ADMIN,
    GET_FUNKTIONSBEREICH_CHECKLISTEN_ADMIN_ERFOLGREICH,
    GET_FUNKTIONSBEREICH_CHECKLISTEN_ADMIN_FEHLER,
    GET_ROLLE_BENUTZER_ADMIN,
    GET_ROLLE_BENUTZER_ADMIN_ERFOLGREICH,
    GET_ROLLE_BENUTZER_ADMIN_FEHLER, GET_VERANSTALTUNG_BERECHTIGUNGEN_ADMIN, GET_VERANSTALTUNG_BERECHTIGUNGEN_ADMIN_ERFOLGREICH, GET_VERANSTALTUNG_BERECHTIGUNGEN_ADMIN_FEHLER,
    GET_VERANSTALTUNG_DETAIL_ADMIN,
    GET_VERANSTALTUNG_DETAIL_ADMIN_ERFOLGREICH,
    GET_VERANSTALTUNG_DOKUMENT_BERECHTIGUNG,
    GET_VERANSTALTUNG_DOKUMENT_BERECHTIGUNG_ERFOLGREICH,
    GET_VERANSTALTUNG_DOKUMENT_BERECHTIGUNG_FEHLER,
    GET_VERANSTALTUNG_DOKUMENTE_ADMIN,
    GET_VERANSTALTUNG_DOKUMENTE_ADMIN_ERFOLGREICH, GET_VERANSTALTUNG_FUNKTIONSBEREICH_AUFGABEN_BENUTZER_BERECHTIGUNGEN_ADMIN, GET_VERANSTALTUNG_FUNKTIONSBEREICH_AUFGABEN_BENUTZER_BERECHTIGUNGEN_ADMIN_ERFOLGREICH, GET_VERANSTALTUNG_FUNKTIONSBEREICH_AUFGABEN_BENUTZER_BERECHTIGUNGEN_ADMIN_FEHLER,
    GET_VERANSTALTUNG_FUNKTIONSBEREICHE_ADMIN,
    GET_VERANSTALTUNG_FUNKTIONSBEREICHE_ADMIN_ERFOLGREICH, GET_VERANSTALTUNG_FUNKTIONSBEREICHE_ADMIN_FEHLER,
    GET_VERANSTALTUNG_FUNKTIONSBEREICHE_CHECKLISTEN_ADMIN,
    GET_VERANSTALTUNG_FUNKTIONSBEREICHE_CHECKLISTEN_ADMIN_ERFOLGREICH,
    GET_VERANSTALTUNG_FUNKTIONSBEREICHE_CHECKLISTEN_ADMIN_FEHLER,
    GET_VERANSTALTUNG_FUNKTIONSBEREICHE_ROLLEN_ADMIN,
    GET_VERANSTALTUNG_FUNKTIONSBEREICHE_ROLLEN_ADMIN_ALLE_ERFOLGREICH,
    GET_VERANSTALTUNG_FUNKTIONSBEREICHE_ROLLEN_ADMIN_ALLE_FEHLER,
    GET_VERANSTALTUNG_FUNKTIONSBEREICHE_ROLLEN_ADMIN_ERFOLGREICH,
    GET_VERANSTALTUNG_FUNKTIONSBEREICHE_ROLLEN_ADMIN_FEHLER,
    GET_VERANSTALTUNG_ROLLEN_ADMIN,
    GET_VERANSTALTUNG_ROLLEN_ADMIN_ERFOLGREICH,
    GET_VERANSTALTUNG_STATUS_ERFOLGREICH,
    GET_VERANSTALTUNGEN_ANGELEGTE_ADMIN,
    GET_VERANSTALTUNGEN_ANGELEGTE_ADMIN_ERFOLGREICH,
    GET_VERANSTALTUNGEN_ANGELEGTE_ADMIN_FEHLER,
    GET_VERANSTALTUNGEN_BEENDETE_ADMIN,
    GET_VERANSTALTUNGEN_BEENDETE_ADMIN_ERFOLGREICH,
    GET_VERANSTALTUNGEN_BEENDETE_ADMIN_FEHLER,
    GET_VERANSTALTUNGEN_VEROEFFENTLICHTE_ADMIN,
    GET_VERANSTALTUNGEN_VEROEFFENTLICHTE_ADMIN_ERFOLGREICH,
    GET_VERANSTALTUNGEN_VEROEFFENTLICHTE_ADMIN_FEHLER,
    GetChecklisteAbarbeiterRollenAdminErfolgreichAction,
    GetChecklisteAufgabenAdminErfolgreichAction,
    GetChecklisteAufgabenAdminFehlerAction,
    GetChecklisteFreigabeRollenAdminErfolgreichAction,
    GetChecklisteLeseRollenAdminErfolgreichAction,
    GetFunktionsbereichChecklistenAdminErfolgreichAction,
    GetFunktionsbereichChecklistenAdminFehlerAction,
    GetRolleBenutzerAdminErfolgreichAction, GetVeranstaltungBerechtigungenAdminErfolgreichAction,
    GetVeranstaltungDetailAdminErfolgreichAction,
    GetVeranstaltungDokumentBerechtigungErfolgreichAction,
    GetVeranstaltungDokumenteAdminErfolgreichAction,
    GetVeranstaltungenAngelegteAdminErfolgreichAction,
    GetVeranstaltungenBeendeteAdminErfolgreichAction,
    GetVeranstaltungenVeroeffentlichteAdminErfolgreichAction, GetVeranstaltungFunktionsbereichAufgabenBenutzerBerechtigungenAdminErfolgreichAction,
    GetVeranstaltungFunktionsbereicheAdminErfolgreichAction, GetVeranstaltungFunktionsbereicheAdminFehlerAction,
    GetVeranstaltungFunktionsbereicheChecklistenAdminErfolgreichAction,
    GetVeranstaltungFunktionsbereicheChecklistenAdminFehlerAction,
    GetVeranstaltungFunktionsbereicheRollenAdminAlleErfolgreichAction,
    GetVeranstaltungFunktionsbereicheRollenAdminErfolgreichAction,
    GetVeranstaltungRollenAdminErfolgreichAction,
    GetVeranstaltungStatusErfolgreichAction, POST_AUFGABEN_BENUTZER_BERECHTIGUNGEN_ENTFERNEN_ERFOLGREICH, POST_AUFGABEN_BENUTZER_BERECHTIGUNGEN_HINZUFUEGEN_ERFOLGREICH,
    POST_BENUTZER_ZUM_DIENST_EINTEILEN_MULTI_ERFOLGREICH,
    POST_VERANSTALTUNG_BEENDEN_ERFOLGREICH,
    POST_VERANSTALTUNG_LOESCHEN_ERFOLGREICH,
    PostBenutzerZumDienstEinteilenMultiErfolgreichAction,
    PostVeranstaltungLoeschenErfolgreichAction
} from '../../../client-ngrx/veranstaltungen';
import {
    AufgabeAdmin,
    Checkliste, ChecklisteAufgabenAdmin2,
    Dokument,
    Funktionsbereich,
    FunktionsbereichChecklisten, FunktionsbereichRolle,
    FunktionsbereichRollen,
    Rolle,
    RolleBenutzer,
    Veranstaltung, VeranstaltungBerechtigung,
    VeranstaltungDetail,
    VeranstaltungStatus
} from '../../../clients/veranstaltungen';
import {DokumentBerechtigung} from '../../../clients/vorlagen';
import {
    GET_VERANSTALTUNG_PANDEMIE_INFO,
    GET_VERANSTALTUNG_PANDEMIE_INFO_ERFOLGREICH,
    GET_VERANSTALTUNG_PANDEMIE_INFO_FEHLER,
    GetVeranstaltungPandemieInfoErfolgreichAction,
    POST_VERANSTALTUNG_PANDEMIE_CHECK_ERFOLGREICH,
    PostVeranstaltungPandemieCheckErfolgreichAction
} from '../../../client-ngrx/pandemie';
import {VeranstaltungPandemieCheck} from '../../../clients/pandemie';
import {VeranstaltungPandemieInfo} from '../../../clients/pandemie';
import {APP_RESET_ACTION} from '@orga-app/appstart/actions';
import {GET_VERANSTALTUNGS_TYP_ROLLE_BENUTZER, GET_VERANSTALTUNGS_TYP_ROLLE_BENUTZER_ERFOLGREICH, GET_VERANSTALTUNGS_TYP_ROLLE_BENUTZER_FEHLER, GetVeranstaltungsTypRolleBenutzerErfolgreichAction} from '../../../client-ngrx/veranstaltungstypen';

export interface ModuleState {
    page: PageState;
}

export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};

export interface PageState {
    // Neu Umbau MKB
    veranstaltungBerechtigungen: VeranstaltungBerechtigung;
    veranstaltungBerechtigungenLaden: boolean;
    veranstaltungBerechtigungenFehler: boolean;

    angelegteVeranstaltungenListe: Array<Veranstaltung>;
    veroeffentlichteVeranstaltungenListe: Array<Veranstaltung>;
    beendeteVeranstaltungenListe: Array<Veranstaltung>;
    veranstaltungenDetail: VeranstaltungDetail;
    veranstaltungStatus: VeranstaltungStatus;
    funktionsbereicheListe: Array<Funktionsbereich>;
    funktionsbereicheChecklistenListe: Array<FunktionsbereichChecklisten>;
    checklistenListe: Array<Checkliste>;
    aufgabenListe: Array<AufgabeAdmin>;
    selectedAufgabe: AufgabeAdmin;
    freigabeRollenListe: Array<FunktionsbereichRolle>;
    leseRollenListe: Array<FunktionsbereichRolle>;
    abarbeiterRollenListe: Array<FunktionsbereichRolle>;
    funktionsbereicheRollenListe: Array<FunktionsbereichRollen>;
    funktionsbereicheRollenAlleListe: Array<FunktionsbereichRollen>;
    veranstaltungRollenListe: Array<Rolle>;
    rolleBenutzerListe: Array<RolleBenutzer>;
    benutzerverwaltungRolleBenutzerListe: Array<RolleBenutzer>;

    dokumenteListe: Array<Dokument>;
    dokumentSelected: Dokument;
    aktuelleRolle: Rolle;

    uiAngelegteVeranstaltungenListeLadeanimation: boolean;
    uiVeroeffentlichteVeranstaltungenListeLadeanimation: boolean;
    uiBeendeteVeranstaltungenListeLadeanimation: boolean;
    uiZeigeVeranstaltungenDetailLadeanimation: boolean;
    uiZeigeFunktionsbereicheLadeanimation: boolean;
    uiZeigeFunktionsbereicheFehler: boolean;
    uiZeigeChecklistenLadeanimation: boolean;
    uiZeigeChecklistenFehler: boolean;
    uiZeigeAufgabenLadeanimation: boolean;
    uiZeigeAufgabenFehler: boolean;
    uiZeigeFreigabeRollenLadeanimation: boolean;
    uiZeigeLeseRollenLadeanimation: boolean;
    uiZeigeAbarbeiterRollenLadeanimation: boolean;
    uiZeigeDetailbereich: boolean;
    uiZeigeFunktionsbereicheRollenLadeanimation: boolean;
    uiZeigeVeranstaltungRollenLadeanimation: boolean;
    uiZeigeRolleBenutzerLadeanimation: boolean;
    uiZeigeBenutzerverwaltungRolleBenutzerLadeanimation: boolean;
    uiZeigeVeranstaltungLoeschen: boolean;
    uiZeigeNeueVeranstaltung: boolean;
    uiZeigeDokumenteLadeanimation: boolean;
    uiZeigeFunktionsbereicheChecklistenLaden: boolean;
    uiZeigeFunktionsbereicheChecklistenFehler: boolean;
    uiSelektiertFunktionsbereicheCheckliste: Checkliste;
    uiRollenBenutzerSelektiert: Array<string>;


    dokumentBerechtigung: DokumentBerechtigung;
    dokumentBerechtigungLaden: boolean;
    dokumentBerechtigungFehler: boolean;

    dokumentLeseBerechtigungenSelected: Array<string>;
    dokumentBearbeitungBerechtigungenSelected: Array<string>;

    pandemieLevelStichtag: Date;
    pandemieCheck: VeranstaltungPandemieCheck;
    selectedPandemieLevelId: number;

    veranstaltungPandemieInfo: VeranstaltungPandemieInfo;
    veranstaltungPandemieInfoLaden: boolean;
    veranstaltungPandemieInfoFehler: boolean;

    selectedFunktionsbereichId: string;

    checklistenAufgaben: Array<ChecklisteAufgabenAdmin2>;
    checklistenAufgabenFehler: boolean;
    checklistenAufgabenLaden: boolean;

    selectedAufgaben: Array<string>;
}

export const initialPageState: PageState = {
    veranstaltungBerechtigungen: {
        benutzer_ist_admin: true,
        benutzer_ist_beobachter: true,
        benutzer_kann_info_kategorien: true,
        benutzer_kann_aktionen: true,
        benutzer_id: 'aaa'
    },
    veranstaltungBerechtigungenLaden: false,
    veranstaltungBerechtigungenFehler: false,
    angelegteVeranstaltungenListe: [],
    veroeffentlichteVeranstaltungenListe: [],
    beendeteVeranstaltungenListe: [],
    veranstaltungenDetail: null,
    veranstaltungStatus: null,
    funktionsbereicheListe: [],
    funktionsbereicheChecklistenListe: [],
    checklistenListe: [],
    aufgabenListe: [],
    selectedAufgabe: null,
    freigabeRollenListe: [],
    leseRollenListe: [],
    abarbeiterRollenListe: [],
    funktionsbereicheRollenListe: [],
    funktionsbereicheRollenAlleListe: [],
    veranstaltungRollenListe: [],
    rolleBenutzerListe: [],
    benutzerverwaltungRolleBenutzerListe: null,

    dokumenteListe: [],
    dokumentSelected: null,
    aktuelleRolle: null,

    uiAngelegteVeranstaltungenListeLadeanimation: false,
    uiVeroeffentlichteVeranstaltungenListeLadeanimation: false,
    uiBeendeteVeranstaltungenListeLadeanimation: false,
    uiZeigeVeranstaltungenDetailLadeanimation: false,
    uiZeigeFunktionsbereicheLadeanimation: false,
    uiZeigeFunktionsbereicheFehler: false,
    uiZeigeChecklistenLadeanimation: false,
    uiZeigeChecklistenFehler: false,
    uiZeigeAufgabenLadeanimation: false,
    uiZeigeAufgabenFehler: false,
    uiZeigeFreigabeRollenLadeanimation: false,
    uiZeigeLeseRollenLadeanimation: false,
    uiZeigeAbarbeiterRollenLadeanimation: false,
    uiZeigeDetailbereich: false,
    uiZeigeFunktionsbereicheRollenLadeanimation: false,
    uiZeigeVeranstaltungRollenLadeanimation: false,
    uiZeigeRolleBenutzerLadeanimation: false,
    uiZeigeBenutzerverwaltungRolleBenutzerLadeanimation: false,
    uiZeigeVeranstaltungLoeschen: false,
    uiZeigeNeueVeranstaltung: false,
    uiZeigeDokumenteLadeanimation: false,
    uiZeigeFunktionsbereicheChecklistenLaden: false,
    uiZeigeFunktionsbereicheChecklistenFehler: false,
    uiSelektiertFunktionsbereicheCheckliste: null,
    uiRollenBenutzerSelektiert: [],

    dokumentBerechtigung: null,
    dokumentBerechtigungLaden: true,
    dokumentBerechtigungFehler: false,

    dokumentLeseBerechtigungenSelected: [],
    dokumentBearbeitungBerechtigungenSelected: [],

    pandemieLevelStichtag: new Date(),
    pandemieCheck: null,
    selectedPandemieLevelId: null,

    veranstaltungPandemieInfo: null,
    veranstaltungPandemieInfoLaden: false,
    veranstaltungPandemieInfoFehler: false,

    selectedFunktionsbereichId: null,

    checklistenAufgaben: [],
    checklistenAufgabenFehler: false,
    checklistenAufgabenLaden: false,

    selectedAufgaben: []
};

export function pageReducer(state = initialPageState, action: Action): PageState {
    switch (action.type) {
        // APP RESET
        case APP_RESET_ACTION: {
            return Object.assign({}, state, <PageState>initialPageState);
        }

        // Page State Reset
        case actionsUi.PAGE_STATE_RESET: {
            const a = <actionsUi.PageStateResetAction>action;

            return Object.assign({}, state, <PageState>initialPageState, {
                angelegteVeranstaltungenListe: state.angelegteVeranstaltungenListe,
                veroeffentlichteVeranstaltungenListe: state.veroeffentlichteVeranstaltungenListe,
                beendeteVeranstaltungenListe: state.beendeteVeranstaltungenListe
            });
        }

        // Page State Reset
        case actionsUi.VERANSTALTUNG_DETAIL_RESET: {
            const a = <actionsUi.VeranstaltungDetailResetAction>action;

            return Object.assign({}, state, <PageState>initialPageState, {
                angelegteVeranstaltungenListe: state.angelegteVeranstaltungenListe,
                veroeffentlichteVeranstaltungenListe: state.veroeffentlichteVeranstaltungenListe,
                beendeteVeranstaltungenListe: state.beendeteVeranstaltungenListe,
                uiZeigeDetailbereich: state.uiZeigeDetailbereich
            });
        }

        // Veranstaltungen
        case GET_VERANSTALTUNGEN_ANGELEGTE_ADMIN: {
            return Object.assign({}, state, <PageState>{
                uiAngelegteVeranstaltungenListeLadeanimation: true
            });
        }

        case GET_VERANSTALTUNGEN_ANGELEGTE_ADMIN_ERFOLGREICH: {
            const a = <GetVeranstaltungenAngelegteAdminErfolgreichAction>action;

            const resultsFiltered = a.payload.filter(x => x.ist_geloescht === false).map(x => Object.assign({}, x));

            return Object.assign({}, state, <PageState>{
                angelegteVeranstaltungenListe: Object.assign([], a.payload, resultsFiltered),
                uiAngelegteVeranstaltungenListeLadeanimation: false
            });
        }
        case GET_VERANSTALTUNGEN_ANGELEGTE_ADMIN_FEHLER: {
            return Object.assign({}, state, <PageState>{
                angelegteVeranstaltungenListe: [],
                uiAngelegteVeranstaltungenListeLadeanimation: false
            });
        }

        case POST_VERANSTALTUNG_LOESCHEN_ERFOLGREICH: {
            const a = <PostVeranstaltungLoeschenErfolgreichAction>action;
            let item = Object.assign([], state.angelegteVeranstaltungenListe);
            item = state.angelegteVeranstaltungenListe.filter(x => x.veranstaltung_id !== a.veranstaltungRequest.veranstaltung_id).map(x => Object.assign([], x));

            return Object.assign({}, state, <PageState>{
                angelegteVeranstaltungenListe: item,
                veranstaltungenDetail: null,
                uiZeigeVeranstaltungenDetailLadeanimation: false,
                uiZeigeDetailbereich: false,
                uiZeigeVeranstaltungLoeschen: false,
                uiZeigeNeueVeranstaltung: false
            });
        }

        case GET_VERANSTALTUNGEN_VEROEFFENTLICHTE_ADMIN: {
            return Object.assign({}, state, <PageState>{
                uiVeroeffentlichteVeranstaltungenListeLadeanimation: true
            });
        }

        case GET_VERANSTALTUNGEN_VEROEFFENTLICHTE_ADMIN_ERFOLGREICH: {
            const a = <GetVeranstaltungenVeroeffentlichteAdminErfolgreichAction>action;

            const resultsFiltered = a.payload.filter(x => x.ist_geloescht === false);

            return Object.assign({}, state, <PageState>{
                veroeffentlichteVeranstaltungenListe: Object.assign([], a.payload, resultsFiltered),
                uiVeroeffentlichteVeranstaltungenListeLadeanimation: false
            });
        }

        case GET_VERANSTALTUNGEN_VEROEFFENTLICHTE_ADMIN_FEHLER: {
            return Object.assign({}, state, <PageState>{
                veroeffentlichteVeranstaltungenListe: [],
                uiVeroeffentlichteVeranstaltungenListeLadeanimation: false
            });
        }

        case GET_VERANSTALTUNGEN_BEENDETE_ADMIN: {
            return Object.assign({}, state, <PageState>{
                uiBeendeteVeranstaltungenListeLadeanimation: true
            });
        }

        case GET_VERANSTALTUNGEN_BEENDETE_ADMIN_ERFOLGREICH: {
            const a = <GetVeranstaltungenBeendeteAdminErfolgreichAction>action;

            const resultsFiltered = a.payload.filter(x => x.ist_geloescht === false);

            return Object.assign({}, state, <PageState>{
                beendeteVeranstaltungenListe: Object.assign([], a.payload, resultsFiltered),
                uiBeendeteVeranstaltungenListeLadeanimation: false
            });
        }

        case GET_VERANSTALTUNGEN_BEENDETE_ADMIN_FEHLER: {
            return Object.assign({}, state, <PageState>{
                beendeteVeranstaltungenListe: [],
                uiBeendeteVeranstaltungenListeLadeanimation: false
            });
        }

        // Veranstaltungen Berechtigungen
        case GET_VERANSTALTUNG_BERECHTIGUNGEN_ADMIN: {
            return Object.assign({}, state, <PageState>{
                veranstaltungBerechtigungenLaden: true,
                veranstaltungBerechtigungenFehler: false
            });
        }

        case GET_VERANSTALTUNG_BERECHTIGUNGEN_ADMIN_ERFOLGREICH: {
            const a = <GetVeranstaltungBerechtigungenAdminErfolgreichAction>action;
            return Object.assign({}, state, <PageState>{
                veranstaltungBerechtigungen: a.payload,
                veranstaltungBerechtigungenLaden: false,
                veranstaltungBerechtigungenFehler: false
            });
        }

        case GET_VERANSTALTUNG_BERECHTIGUNGEN_ADMIN_FEHLER: {
            return Object.assign({}, state, <PageState>{
                veranstaltungBerechtigungen: null,
                veranstaltungBerechtigungenLaden: false,
                veranstaltungBerechtigungenFehler: true
            });
        }

        // VeranstaltungsDetail
        case GET_VERANSTALTUNG_DETAIL_ADMIN: {
// TODO Hier wird entweder zuviel gelöscht oder es muss bei erfolgreichem laden noch das einzelne nachgeladen werden
            return Object.assign({}, state, <PageState>{
                uiZeigeVeranstaltungenDetailLadeanimation: true,
                // funktionsbereicheListe: [],

                // TODO Testen ob das ok ist, wenn hier alles nicht reseted wird
                    // checklistenListe: [],
                    // aufgabenListe: [],
                    // funktionsbereicheRollenListe: [],
                    // veranstaltungRollenListe: [],
                    // rolleBenutzerListe: [],
                    // benutzerverwaltungRolleBenutzerListe: [],
                    // dokumenteListe: [],
                    // veranstaltungStatus: null
            });
        }

        case GET_VERANSTALTUNG_DETAIL_ADMIN_ERFOLGREICH: {
            const a = <GetVeranstaltungDetailAdminErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                veranstaltungenDetail: a.payload,
                uiZeigeVeranstaltungenDetailLadeanimation: false,
                uiZeigeDetailbereich: true,
                uiZeigeVeranstaltungLoeschen: true,
                uiZeigeNeueVeranstaltung: false
            });
        }

        // Veranstaltung Status
        case GET_VERANSTALTUNG_STATUS_ERFOLGREICH: {
            const a = <GetVeranstaltungStatusErfolgreichAction>action;
            return Object.assign({}, state, <PageState>{
                veranstaltungStatus: a.payload
            });
        }


        // Neue Veranstaltung
        case actionsUi.NEUE_VERANSTALTUNG: {
            return Object.assign({}, state, <PageState>{
                veranstaltungenDetail: <VeranstaltungDetail>{titel: ''},
                uiZeigeDetailbereich: false,
                uiZeigeNeueVeranstaltung: true,
                uiZeigeVeranstaltungLoeschen: false
            });
        }

        case actionsUi.NEUE_VERANSTALTUNG_DETAIL_SETZEN: {
            const a = <NeueVeranstaltungDetailSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                veranstaltungenDetail: a.detail
            });
        }

        case actionsUi.NEUE_VERANSTALTUNG_ABBRECHEN: {
            return Object.assign({}, state, <PageState>{
                veranstaltungenDetail: null,
                uiZeigeDetailbereich: false,
                uiZeigeNeueVeranstaltung: false,
                uiZeigeVeranstaltungLoeschen: false
            });
        }


        // Veranstaltung beenden
        case POST_VERANSTALTUNG_BEENDEN_ERFOLGREICH: {
            return Object.assign({}, state, <PageState>{
                veranstaltungenDetail: null,
                uiZeigeDetailbereich: false,
                uiZeigeNeueVeranstaltung: false,
                uiZeigeVeranstaltungLoeschen: false
            });
        }

        // Veranstaltung Feld ändern
        case SETZE_VERANSTALTUNG_FELD: {
            const a = <SetzeVeranstaltungFeldAction>action;

            let kopfdaten = [...state.veranstaltungenDetail.kopfdaten];

            kopfdaten = kopfdaten.map(kdElement => {
                const kdElementNeu = Object.assign({}, kdElement);

                if (kdElementNeu.feld_typ === 'FELD' && kdElementNeu.key === a.key) {
                    kdElementNeu.wert = a.wert;
                } else if (kdElementNeu.feld_typ === 'GRUPPE') {
                    kdElementNeu.children = kdElementNeu.children.map(kdElement2 => {
                        const kdElement2Neu = Object.assign({}, kdElement2);

                        if (kdElement2Neu.feld_typ === 'FELD' && kdElement2Neu.key === a.key) {
                            kdElement2Neu.wert = a.wert;
                        }
                        return kdElement2Neu;
                    });
                } else {

                }
                return kdElementNeu;
            });

            const detail = Object.assign({}, state.veranstaltungenDetail, {
                kopfdaten
            });

            return Object.assign({}, state, <PageState>{
                veranstaltungenDetail: detail
            });
        }

        // Veranstaltung Titel ändern
        case SETZE_VERANSTALTUNG_TITEL: {
            const a = <SetzeVeranstaltungTitelAction>action;

            const detail = Object.assign({}, state.veranstaltungenDetail);
            detail.titel = a.titel;

            return Object.assign({}, state, <PageState>{
                veranstaltungenDetail: detail
            });
        }

        // Veranstaltung Einlass ändern
        case SETZE_VERANSTALTUNG_EINLASS: {
            const a = <SetzeVeranstaltungEinlassAction>action;

            const detail = Object.assign({}, state.veranstaltungenDetail);
            detail.einlass_utc = a.einlass;
            detail.beginn_utc = a.einlass;

            return Object.assign({}, state, <PageState>{
                veranstaltungenDetail: detail
            });
        }

        // Veranstaltung Beginn ändern
        case SETZE_VERANSTALTUNG_BEGINN: {
            const a = <SetzeVeranstaltungBeginnAction>action;

            const detail = Object.assign({}, state.veranstaltungenDetail);
            detail.beginn_utc = a.beginn;

            return Object.assign({}, state, <PageState>{
                veranstaltungenDetail: detail
            });
        }

        // Veranstaltung Saison ändern
        case SETZE_VERANSTALTUNG_SAISON: {
            const a = <SetzeVeranstaltungSaisonAction>action;

            const detail = Object.assign({}, state.veranstaltungenDetail);
            // TODO: TBR SAISON CHECK
            detail.saison_id = a.saison_id;

            return Object.assign({}, state, <PageState>{
                veranstaltungenDetail: detail
            });
        }

        // Veranstaltung Veranstaltungsleiter ändern
        case SETZE_VERANSTALTUNG_VERANSTALTUNGSLEITER: {
            const a = <SetzeVeranstaltungVeranstaltungsleiterAction>action;

            const detail = Object.assign({}, state.veranstaltungenDetail);
            detail.veranstaltungsleiter_rolle_id = a.payload;

            return Object.assign({}, state, <PageState>{
                veranstaltungenDetail: detail
            });
        }

        // Veranstaltung Veranstaltungsbeobachter ändern
        case SETZE_VERANSTALTUNG_VERANSTALTUNGSBEOBACHTER: {
            const a = <SetzeVeranstaltungVeranstaltungsbeobachterAction>action;

            const detail = Object.assign({}, state.veranstaltungenDetail);
            detail.beobachter_rolle_id = a.payload;

            return Object.assign({}, state, <PageState>{
                veranstaltungenDetail: detail
            });
        }

        // Funktionsbereiche
        case GET_VERANSTALTUNG_FUNKTIONSBEREICHE_ADMIN: {

            return Object.assign({}, state, <PageState>{
                uiZeigeFunktionsbereicheLadeanimation: true,
                uiZeigeFunktionsbereicheFehler: false
            });
        }

        case GET_VERANSTALTUNG_FUNKTIONSBEREICHE_ADMIN_ERFOLGREICH: {
            const a = <GetVeranstaltungFunktionsbereicheAdminErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                funktionsbereicheListe: a.payload,
                uiZeigeFunktionsbereicheLadeanimation: false
            });
        }



        case GET_VERANSTALTUNG_FUNKTIONSBEREICHE_ADMIN_FEHLER: {
            const a = <GetVeranstaltungFunktionsbereicheAdminFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                funktionsbereicheListe: [],
                uiZeigeFunktionsbereicheLadeanimation: false,
                uiZeigeFunktionsbereicheFehler: true
            });
        }

        case actionsUi.FUNKTIONSBEREICH_CHECKLISTE_SETZEN: {
            const a = <actionsUi.FunktionsbereichChecklisteSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                uiSelektiertFunktionsbereicheCheckliste: a.checkliste
            });
        }


        // Funktionsbereiche Checklisten
        case GET_VERANSTALTUNG_FUNKTIONSBEREICHE_CHECKLISTEN_ADMIN: {

            return Object.assign({}, state, <PageState>{
                uiZeigeFunktionsbereicheChecklistenLaden: true
            });
        }

        case GET_VERANSTALTUNG_FUNKTIONSBEREICHE_CHECKLISTEN_ADMIN_ERFOLGREICH: {
            const a = <GetVeranstaltungFunktionsbereicheChecklistenAdminErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                funktionsbereicheChecklistenListe: a.payload,
                uiZeigeFunktionsbereicheChecklistenLaden: false,
                uiZeigeFunktionsbereicheChecklistenFehler: false
            });
        }

        case GET_VERANSTALTUNG_FUNKTIONSBEREICHE_CHECKLISTEN_ADMIN_FEHLER: {
            const a = <GetVeranstaltungFunktionsbereicheChecklistenAdminFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                funktionsbereicheChecklistenListe: [],
                uiZeigeFunktionsbereicheChecklistenLaden: false,
                uiZeigeFunktionsbereicheChecklistenFehler: true
            });
        }




        // Checklisten
        case GET_FUNKTIONSBEREICH_CHECKLISTEN_ADMIN: {

            return Object.assign({}, state, <PageState>{
                uiZeigeChecklistenLadeanimation: true
            });
        }

        case GET_FUNKTIONSBEREICH_CHECKLISTEN_ADMIN_ERFOLGREICH: {
            const a = <GetFunktionsbereichChecklistenAdminErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                checklistenListe: a.payload,
                uiZeigeChecklistenLadeanimation: false,
                uiZeigeChecklistenFehler: false
            });
        }

        case GET_FUNKTIONSBEREICH_CHECKLISTEN_ADMIN_FEHLER: {
            const a = <GetFunktionsbereichChecklistenAdminFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                checklistenListe: [],
                uiZeigeChecklistenLadeanimation: false,
                uiZeigeChecklistenFehler: true
            });
        }


        // Aufgaben
        case GET_CHECKLISTE_AUFGABEN_ADMIN: {

            return Object.assign({}, state, <PageState>{
                uiZeigeAufgabenLadeanimation: true
            });
        }

        case GET_CHECKLISTE_AUFGABEN_ADMIN_ERFOLGREICH: {
            const a = <GetChecklisteAufgabenAdminErfolgreichAction>action;

            let selectedAufgabe = state.selectedAufgabe;

            if (selectedAufgabe !== null) {
                if (a.payload.findIndex(x => x.aufgabe_id === selectedAufgabe.aufgabe_id) > -1) {
                    selectedAufgabe  = a.payload.find(x => x.aufgabe_id === selectedAufgabe.aufgabe_id);
                } else {
                    selectedAufgabe = null;
                }
            }

            return Object.assign({}, state, <PageState>{
                aufgabenListe: a.payload,
                uiZeigeAufgabenLadeanimation: false,
                uiZeigeAufgabenFehler: false,
                selectedAufgabe
            });
        }

        case GET_CHECKLISTE_AUFGABEN_ADMIN_FEHLER: {
            const a = <GetChecklisteAufgabenAdminFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                aufgabenListe: [],
                uiZeigeAufgabenLadeanimation: false,
                uiZeigeAufgabenFehler: true
            });
        }

        case AUFGABE_SETZEN: {
            const a = <AufgabeSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                selectedAufgabe: a.aufgabe
            });
        }

        // Freigabe Rollen
        case GET_CHECKLISTE_FREIGABE_ROLLEN_ADMIN: {

            return Object.assign({}, state, <PageState>{
                uiZeigeFreigabeRollenLadeanimation: true
            });
        }

        case GET_CHECKLISTE_FREIGABE_ROLLEN_ADMIN_ERFOLGREICH: {
            const a = <GetChecklisteFreigabeRollenAdminErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                freigabeRollenListe: a.payload,
                uiZeigeFreigabeRollenLadeanimation: false
            });
        }


        // Lese Rollen
        case GET_CHECKLISTE_LESE_ROLLEN_ADMIN: {

            return Object.assign({}, state, <PageState>{
                uiZeigeLeseRollenLadeanimation: true
            });
        }

        case GET_CHECKLISTE_LESE_ROLLEN_ADMIN_ERFOLGREICH: {
            const a = <GetChecklisteLeseRollenAdminErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                leseRollenListe: a.payload,
                uiZeigeLeseRollenLadeanimation: false
            });
        }

        case GET_CHECKLISTE_LESE_ROLLEN_ADMIN_FEHLER: {
            return Object.assign({}, state, <PageState>{
                leseRollenListe: [],
                uiZeigeLeseRollenLadeanimation: false
            });
        }


        // Abarbeiter Rollen
        case GET_CHECKLISTE_ABARBEITER_ROLLEN_ADMIN: {

            return Object.assign({}, state, <PageState>{
                uiZeigeAbarbeiterRollenLadeanimation: true
            });
        }

        case GET_CHECKLISTE_ABARBEITER_ROLLEN_ADMIN_ERFOLGREICH: {
            const a = <GetChecklisteAbarbeiterRollenAdminErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                abarbeiterRollenListe: a.payload,
                uiZeigeAbarbeiterRollenLadeanimation: false
            });
        }

        case GET_CHECKLISTE_ABARBEITER_ROLLEN_ADMIN_FEHLER: {
            return Object.assign({}, state, <PageState>{
                abarbeiterRollenListe: [],
                uiZeigeAbarbeiterRollenLadeanimation: false
            });
        }

        // Funktionsbereiche Rollen
        case GET_VERANSTALTUNG_FUNKTIONSBEREICHE_ROLLEN_ADMIN: {

            return Object.assign({}, state, <PageState>{
                uiZeigeFunktionsbereicheRollenLadeanimation: true
            });
        }

        case GET_VERANSTALTUNG_FUNKTIONSBEREICHE_ROLLEN_ADMIN_ERFOLGREICH: {
            const a = <GetVeranstaltungFunktionsbereicheRollenAdminErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                funktionsbereicheRollenListe: a.payload,
                uiZeigeFunktionsbereicheRollenLadeanimation: false
            });
        }

        case GET_VERANSTALTUNG_FUNKTIONSBEREICHE_ROLLEN_ADMIN_FEHLER: {
            return Object.assign({}, state, <PageState>{
                funktionsbereicheRollenListe: [],
                uiZeigeFunktionsbereicheRollenLadeanimation: false
            });
        }

        case GET_VERANSTALTUNG_FUNKTIONSBEREICHE_ROLLEN_ADMIN_ALLE_ERFOLGREICH: {
            const a = <GetVeranstaltungFunktionsbereicheRollenAdminAlleErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                funktionsbereicheRollenAlleListe: a.payload,
                uiZeigeFunktionsbereicheRollenLadeanimation: false
            });
        }

        case GET_VERANSTALTUNG_FUNKTIONSBEREICHE_ROLLEN_ADMIN_ALLE_FEHLER: {
            return Object.assign({}, state, <PageState>{
                funktionsbereicheRollenAlleListe: [],
                uiZeigeFunktionsbereicheRollenLadeanimation: false
            });
        }

        // Veranstaltung Rollen
        case GET_VERANSTALTUNG_ROLLEN_ADMIN: {

            return Object.assign({}, state, <PageState>{
                uiZeigeVeranstaltungRollenLadeanimation: true
            });
        }

        case GET_VERANSTALTUNG_ROLLEN_ADMIN_ERFOLGREICH: {
            const a = <GetVeranstaltungRollenAdminErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                veranstaltungRollenListe: a.payload,
                uiZeigeVeranstaltungRollenLadeanimation: false
            });
        }

        // Rolle Benutzer
        case GET_ROLLE_BENUTZER_ADMIN: {

            return Object.assign({}, state, <PageState>{
                uiZeigeRolleBenutzerLadeanimation: true
            });
        }

        case GET_ROLLE_BENUTZER_ADMIN_ERFOLGREICH: {
            const a = <GetRolleBenutzerAdminErfolgreichAction>action;

            // SCHON DIENSTHABENDE BENUTZER
            if (state.benutzerverwaltungRolleBenutzerListe != null) {
                const filteredUsers = state.benutzerverwaltungRolleBenutzerListe.filter(x => {
                    const res = a.payload.find(y => y.benutzer_id === x.benutzer_id);
                    return res === null || res === undefined;
                });

                return Object.assign({}, state, <PageState>{
                    rolleBenutzerListe: a.payload,
                    uiZeigeRolleBenutzerLadeanimation: false
                });
            } else {
                return Object.assign({}, state, <PageState>{
                    rolleBenutzerListe: a.payload,
                    uiZeigeRolleBenutzerLadeanimation: false
                });
            }


        }

        case GET_ROLLE_BENUTZER_ADMIN_FEHLER: {
            return Object.assign({}, state, <PageState>{
                rolleBenutzerListe: [],
                uiZeigeRolleBenutzerLadeanimation: false
            });
        }

        // Aktuelle Rolle Setzen
        case ROLLE_SETZEN: {
            const a = <RolleSetzenAction>action;
            return Object.assign({}, state, <PageState>{
                aktuelleRolle: a.rolle,
                uiRollenBenutzerSelektiert: []
            });
        }


        // Rolle Benutzer
        case GET_VERANSTALTUNGS_TYP_ROLLE_BENUTZER: {

            return Object.assign({}, state, <PageState>{
                uiZeigeBenutzerverwaltungRolleBenutzerLadeanimation: true
            });
        }

        case GET_VERANSTALTUNGS_TYP_ROLLE_BENUTZER_ERFOLGREICH: {
            const a = <GetVeranstaltungsTypRolleBenutzerErfolgreichAction>action;

            // SCHON DIENSTHABENDE BENUTZER
            const filteredUsers = a.payload.filter(x => {
                let res = null;
                if (state.rolleBenutzerListe != null) {
                    res = state.rolleBenutzerListe.find(y => y.benutzer_id === x.benutzer_id);
                }
                return res === null || res === undefined;
            });

            return Object.assign({}, state, <PageState>{
                benutzerverwaltungRolleBenutzerListe: a.payload,
                uiZeigeBenutzerverwaltungRolleBenutzerLadeanimation: false
            });
        }

        case GET_VERANSTALTUNGS_TYP_ROLLE_BENUTZER_FEHLER: {
            return Object.assign({}, state, <PageState>{
                benutzerverwaltungRolleBenutzerListe: [],
                uiZeigeBenutzerverwaltungRolleBenutzerLadeanimation: false
            });
        }


        // dokumente
        case GET_VERANSTALTUNG_DOKUMENTE_ADMIN: {
            return Object.assign({}, state, <PageState>{
                uiZeigeDokumenteLadeanimation: true
            });
        }

        case GET_VERANSTALTUNG_DOKUMENTE_ADMIN_ERFOLGREICH: {
            const a = <GetVeranstaltungDokumenteAdminErfolgreichAction>action;

            let dokumentSelected = Object.assign({}, state.dokumentSelected);

            if (dokumentSelected !== null) {
                if (a.payload.findIndex(x => x.dokument_id === dokumentSelected.dokument_id) > -1) {
                    dokumentSelected = a.payload.find(x => x.dokument_id === dokumentSelected.dokument_id);
                } else {
                    dokumentSelected = null;
                }
            }

            // console.log('aktualisierte Dokumente: ', a.payload, dokumentSelected);

            return Object.assign({}, state, <PageState>{
                dokumenteListe: a.payload,
                dokumentSelected,
                uiZeigeDokumenteLadeanimation: false
            });
        }


        case actionsUi.ROLLEN_BENUTZER_SETZEN: {
            const a = <actionsUi.RollenBenutzerSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                uiRollenBenutzerSelektiert: a.payload
            });
        }

        case POST_BENUTZER_ZUM_DIENST_EINTEILEN_MULTI_ERFOLGREICH: {
            const a = <PostBenutzerZumDienstEinteilenMultiErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                uiRollenBenutzerSelektiert: []
            });
        }



        // DOKUMENT BERECHTIGUNG LADEN
        case GET_VERANSTALTUNG_DOKUMENT_BERECHTIGUNG: {
            return Object.assign({}, state, <PageState>{
                dokumentBerechtigungLaden: true,
                dokumentBerechtigungFehler: false
            });
        }

        case GET_VERANSTALTUNG_DOKUMENT_BERECHTIGUNG_ERFOLGREICH: {
            const a = <GetVeranstaltungDokumentBerechtigungErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                dokumentBerechtigung: a.payload,
                dokumentBerechtigungLaden: false,
                dokumentBerechtigungFehler: false
            });
        }

        case GET_VERANSTALTUNG_DOKUMENT_BERECHTIGUNG_FEHLER: {
            return Object.assign({}, state, <PageState>{
                dokumentBerechtigung: null,
                dokumentBerechtigungLaden: false,
                dokumentBerechtigungFehler: true,
            });
        }

        case SETZE_VERANSTALTUNG_STICHTAG_PANDEMIE_LEVEL: {
            const a = <SetzeVeranstaltungStichtagPandemieLevelAction>action;

            return Object.assign({}, state, <PageState>{
                pandemieLevelStichtag: a.stichtag
            });
        }

        case DOKUMENT_SELECTED_SETZEN: {
            const a = <DokumentSelectedSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                dokumentSelected: a.payload
            });
        }

        case AKTUELLES_DOKUMENT_AENDERN: {
            const a = <AktuellesDokumentAendernAction>action;

            return Object.assign({}, state, <PageState>{
                dokumentSelected: a.dokument
            });
        }

        case DOKUMENT_UPLOAD_SETZEN: {
            const a = <DokumentUploadSetzenAction>action;

            const dokumentSelected = Object.assign({}, state.dokumentSelected, <Dokument>{
                dokument_upload_id: a.uploadId,
                dateiname: a.dateiname
            });

            return Object.assign({}, state, <PageState>{
                dokumentSelected
            });
        }

        case DOKUMENT_ID_SETZEN: {
            const a = <DokumentIdSetzenAction>action;

            const dokumentSelected = Object.assign({}, state.dokumentSelected, <Dokument>{
                dokument_id: a.id
            });

            return Object.assign({}, state, <PageState>{
                dokumentSelected
            });
        }

        case DOKUMENT_LESE_BERECHTIGUNGEN_SELECTED_SETZEN: {
            const a = <DokumentLeseBerechtigungenSelectedSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                dokumentLeseBerechtigungenSelected: a.payload
            });
        }

        case DOKUMENT_BEARBEITEN_BERECHTIGUNGEN_SELECTED_SETZEN: {
            const a = <DokumentBearbeitenBerechtigungenSelectedSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                dokumentBearbeitungBerechtigungenSelected: a.payload
            });
        }

        case POST_VERANSTALTUNG_PANDEMIE_CHECK_ERFOLGREICH: {
            const a = <PostVeranstaltungPandemieCheckErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                pandemieCheck: a.payload,
                selectedPandemieLevelId: a.payload.pandemie_level_id
            });
        }

        case SETZE_PANDEMIE_LEVEL_UI: {
            const a = <SetzePandemieLevelUiAction>action;

            return Object.assign({}, state, <PageState>{
                selectedPandemieLevelId: a.level.level_id
            });
        }



        // DOKUMENT BERECHTIGUNG LADEN
        case GET_VERANSTALTUNG_PANDEMIE_INFO: {
            return Object.assign({}, state, <PageState>{
                veranstaltungPandemieInfoLaden: true,
                veranstaltungPandemieInfoFehler: false
            });
        }

        case GET_VERANSTALTUNG_PANDEMIE_INFO_ERFOLGREICH: {
            const a = <GetVeranstaltungPandemieInfoErfolgreichAction>action;

            let pandemieLevelStichtag: Date = null;
            if (a.payload.letzter_pandemie_check !== undefined && a.payload.letzter_pandemie_check !== null) {
                pandemieLevelStichtag = new Date(a.payload.letzter_pandemie_check.stichtag_utc);
            }

            return Object.assign({}, state, <PageState>{
                veranstaltungPandemieInfo: a.payload,
                veranstaltungPandemieInfoLaden: false,
                veranstaltungPandemieInfoFehler: false,
                selectedPandemieLevelId: a.payload.pandemie_level_id,
                pandemieCheck: a.payload.letzter_pandemie_check,
                pandemieLevelStichtag
            });
        }

        case GET_VERANSTALTUNG_PANDEMIE_INFO_FEHLER: {
            return Object.assign({}, state, <PageState>{
                dokumentBerechtigung: null,
                veranstaltungPandemieInfoLaden: false,
                veranstaltungPandemieInfoFehler: true,
            });
        }

        case FUNKTIONSBEREICH_SETZEN: {
            const a = <FunktionsbereichSetzenAction> action;

            return Object.assign({}, state, <PageState>{
                selectedFunktionsbereichId: a.fbId
            });
        }

        case GET_VERANSTALTUNG_FUNKTIONSBEREICH_AUFGABEN_BENUTZER_BERECHTIGUNGEN_ADMIN: {
            return Object.assign({}, state, <PageState> {
                checklistenAufgabenLaden: true,
                checklistenAufgabenFehler: false
            });
        }

        case GET_VERANSTALTUNG_FUNKTIONSBEREICH_AUFGABEN_BENUTZER_BERECHTIGUNGEN_ADMIN_ERFOLGREICH: {
            const a = <GetVeranstaltungFunktionsbereichAufgabenBenutzerBerechtigungenAdminErfolgreichAction> action;

            return Object.assign({}, state, <PageState> {
                checklistenAufgabenLaden: false,
                checklistenAufgabenFehler: false,
                checklistenAufgaben: a.payload
            });
        }

        case GET_VERANSTALTUNG_FUNKTIONSBEREICH_AUFGABEN_BENUTZER_BERECHTIGUNGEN_ADMIN_FEHLER: {
            return Object.assign({}, state, <PageState> {
                checklistenAufgabenLaden: false,
                checklistenAufgabenFehler: true
            });
        }

        case SET_SELECTED_AUFGABEN: {
            const a = <SetSelectedAufgabenAction> action;

            return Object.assign({}, state, <PageState> {
                selectedAufgaben: a.payload
            });
        }

        case POST_AUFGABEN_BENUTZER_BERECHTIGUNGEN_HINZUFUEGEN_ERFOLGREICH: {
            return Object.assign({}, state, <PageState> {
                selectedAufgaben: []
            });
        }

        case POST_AUFGABEN_BENUTZER_BERECHTIGUNGEN_ENTFERNEN_ERFOLGREICH: {
            return Object.assign({}, state, <PageState> {
                selectedAufgaben: []
            });
        }

        default: {
            return state;
        }
    }
}

